import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from './utils/Toast';
import Loader from './utils/Loader';
import Navbar from './utils/Navbr';
import './style/Settings.css';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);
    const [settings, setSettings] = useState({});

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- Fetch Settings ---
    const fetchSettings = async () => {
        setLoading(true);
        const adminToken = getCookie('adminToken');
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'fetchGlobalSettings',
                adminToken: adminToken || 'demo_token'
            });

            if (response.data.status === true) {
                setSettings(response.data.data);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const adminToken = getCookie('adminToken');

        const init = async () => {
            try {
                // ✅ 1. Admin Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'checkAuthAdmin',
                    adminToken
                });

                if (!authRes.data.status) {
                    toast.error(authRes.data.message || 'Admin session expired');
                    navigate('/cbMediaAdmin7/login');
                    return;
                }


                fetchSettings();
            } catch (err) {
                toast.error('Admin auth check failed');
                navigate('/cbMediaAdmin7/login');
            } finally {
                setLoader(false);
            }
        };
        init();
    }, []);

    // --- Handlers ---
    const handleInputChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'updateGlobalSettings',
                settings: settings,
                adminToken: getCookie('adminToken') || 'demo_token'
            });

            if (response.data.status === true) {
                toast.success(response.data.message || "Settings Updated Successfully");
            } else {
                toast.success("Settings Updated (Demo)");
            }
        } catch (error) {
            toast.error("Server Error");
        } finally {
            setSaving(false);
        }
    };

    // --- Helper: Format Key to Label ---
    const formatLabel = (key) => {
        return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    };

    // --- Helper: Render Input based on Logic ---
    const renderInput = (key, value) => {
        const isPostback = key.toLowerCase().includes('postback');
        const isBoolean = value === 'true' || value === 'false' || value === true || value === false;

        // 1. Postback (Read Only)
        if (isPostback) {
            return (
                <div className="input-wrapper_set readonly">
                    <input
                        type="text"
                        value={value}
                        readOnly
                        className="glass-input_set"
                    />
                    <span className="lock-icon_set">🔒</span>
                </div>
            );
        }

        // 2. Boolean (Select)
        if (isBoolean) {
            return (
                <div className="select-wrapper_set">
                    <select
                        value={value.toString()}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                        className={`glass-select_set ${value.toString() === 'true' ? 'active' : 'inactive'}`}
                    >
                        <option value="true">Enabled / True</option>
                        <option value="false">Disabled / False</option>
                    </select>
                    <span className="arrow_set">▼</span>
                </div>
            );
        }

        // 3. Default (Text)
        return (
            <div className="input-wrapper_set">
                <input
                    type="text"
                    value={value}
                    onChange={(e) => handleInputChange(key, e.target.value)}
                    className="glass-input_set"
                />
            </div>
        );
    };
    if (loader) return <Loader />;
    return (
        <div className="settings-wrapper_set">
            <Navbar role="Administrator" isAdmin={true} />

            <div className="bg-shape_set shape-1_set"></div>
            <div className="bg-shape_set shape-2_set"></div>

            <div className="settings-content_set">

                <div className="settings-header_set">
                    <h2>Global <span className="highlight_set">Settings</span></h2>
                    <p>Configure system variables and integration parameters</p>
                </div>

                {loading ? <div className="loader-container_perf"><div className="spinner_perf"></div><p>Loading Data...</p></div> : (
                    <div className="settings-card_set">

                        <div className="settings-grid_set">
                            {Object.entries(settings).map(([key, value], index) => (
                                <div
                                    key={key}
                                    className={`setting-item_set ${key.toLowerCase().includes('postback') ? 'full-width_set' : ''}`}
                                    style={{ animationDelay: `${index * 0.05}s` }}
                                >
                                    <label>{formatLabel(key)}</label>
                                    {renderInput(key, value)}
                                </div>
                            ))}
                        </div>

                        <div className="settings-footer_set">
                            <button
                                className="save-btn_set"
                                onClick={handleSave}
                                disabled={saving}
                            >
                                {saving ? 'SAVING...' : 'SAVE CHANGES'}
                                <div className="wave_set"></div>
                            </button>
                        </div>

                    </div>
                )}

            </div>
        </div>
    );
};

export default Settings;